<template>
  <div v-if="brackets.length" class="product-bracket-prices">
    <template v-if="tStatic('bracketPriceHeading')">
      <oie-product-price-group
        v-for="(item, i) in brackets"
        :key="i"
        :heading="tStatic('bracketPriceHeading').replace('{0}', item.quantity)"
        :price-ex-vat="item.exVat"
        :price-inc-vat="item.incVat"
        :suffix="tStatic('bracketPricePerUnit')"></oie-product-price-group>
    </template>

    <!-- Until the heading text is in place, the sentence these prices used before (OC-3012). -->
    <template v-else>
      <div v-for="(item, i) in brackets" :key="i">
        <span class="product-price">{{ tStatic('bracketPriceText').replace('{0}', item.quantity).replace('{1}', formatPrice(item.price)) }}</span>
      </div>
    </template>
  </div>
</template>

<script>
/**
 * The volume prices of an article: per quantity a heading, then the price the way the visitor's
 * VAT switch says with the other way beneath it, each per unit (OC-3012). A response without the
 * separate figures shows the switch-following price alone.
 */
export default {
  props: {
    bracketPrices: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    brackets() {
      return (this.bracketPrices || []).map(item => {
        const hasBoth = item.priceExVat !== undefined && item.priceExVat !== null &&
          item.priceIncVat !== undefined && item.priceIncVat !== null
        const price = Number(item.price) || 0
        return {
          quantity: item.quantity,
          price,
          exVat: hasBoth ? Number(item.priceExVat) : price,
          incVat: hasBoth ? Number(item.priceIncVat) : price
        }
      })
    }
  }
}
</script>

<style lang="scss">
.product-bracket-prices {
  margin-top: measure(eighth);
}
</style>
